import { Modal } from '../../modal/js/global';

/**
 * Hamburger selector
 * @const {string}
 */
const HAMBURGER_MENU_SELECTOR = '[data-component="hamburger-menu"]';

export default function _hamburgerMenu() {
    /**
     * Hamburger active/open class
     * @const {string}
     */
    const HAMBURGER_MENU_ACTIVE = 'hamburger-menu-wrapper--active';

    /**
     * Hamburger submenu toggle control
     * @const {string}
     */
    const HAMBURGER_SUB_MENU_TOGGLE =
        '[data-click="hamburger-menu-toggle-submenu"]';

    /**
     * Hamburger submenu active/open class
     * @const {string}
     */
    const HAMBURGER_SUB_MENU_ACTIVE = 'hamburger-menu-item__dropdown--active';

    /**
     * Hamburger toggle control
     * @const {string}
     */
    const HAMBURGER_MENU_TOGGLE = '[data-click="hamburger-menu-toggle"]';

    /**
     * Hamburger close control
     * @const {string}
     */
    const HAMBURGER_MENU_CLOSE = '[data-click="hamburger-menu-close"]';

    /**
     * Hamburger dropdown
     * @const {string}
     */
    const HAMBURGER_DIALOG = '[role="dialog"]';

    class HamburgerMenu {
        constructor(hamburgerMenuWrapper) {
            this.hamburgerMenuWrapper = hamburgerMenuWrapper;
            this.hamburger =
                hamburgerMenuWrapper.querySelector(HAMBURGER_DIALOG);

            this.modalHandler = new Modal(hamburgerMenuWrapper);

            hamburgerMenuWrapper
                .querySelectorAll(HAMBURGER_MENU_TOGGLE)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.toggleMenu();
                    });
                });

            hamburgerMenuWrapper
                .querySelectorAll(HAMBURGER_MENU_CLOSE)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.closeMenu();
                    });
                });

            // Attach on item click handler
            hamburgerMenuWrapper
                .querySelectorAll(HAMBURGER_SUB_MENU_TOGGLE)
                .forEach((subMenuToggle) => {
                    subMenuToggle.addEventListener('click', () => {
                        this._handleToggleSubMenu(subMenuToggle);
                    });
                });
        }

        /**
         * Open the hamburger menu
         */
        openMenu() {
            // Tag the toggle button as expanded
            this.hamburgerMenuWrapper
                .querySelector(HAMBURGER_MENU_TOGGLE)
                .setAttribute('aria-expanded', true);

            this.hamburgerMenuWrapper
                .querySelector(HAMBURGER_DIALOG)
                .classList.add(HAMBURGER_MENU_ACTIVE);

            function listener(event) {
                if (!this.hamburgerMenuWrapper.contains(event.target)) {
                    this.closeMenu();
                }
            }
            this.fadeInDocListener = listener.bind(this);

            document.addEventListener('click', this.fadeInDocListener);
        }

        /**
         * Close the hamburger menu
         */
        closeMenu() {
            // Tag the toggle button as not expanded
            this.hamburgerMenuWrapper
                .querySelector(HAMBURGER_MENU_TOGGLE)
                .setAttribute('aria-expanded', false);

            this.hamburgerMenuWrapper
                .querySelector(HAMBURGER_DIALOG)
                .classList.remove(HAMBURGER_MENU_ACTIVE);

            document.removeEventListener('click', this.fadeInDocListener);
            this.fadeInDocListener = undefined;
        }

        /**
         * Toggle the hamburger menu
         */
        toggleMenu() {
            if (this.isOpen()) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        }

        /**
         * Event handler for sub menu item click
         * @param {HTMLElement} subMenu - The sub menu item DOM Element
         */
        _handleToggleSubMenu(subMenuToggle) {
            const subMenu = document.getElementById(
                subMenuToggle.getAttribute('aria-controls')
            );

            if (subMenuToggle.getAttribute('aria-expanded') === 'false') {
                subMenuToggle.setAttribute('aria-expanded', true);
                this._transitionItemMenuOpen(subMenu);
            } else {
                subMenuToggle.setAttribute('aria-expanded', false);
                this._transitionItemMenuClosed(subMenu);
            }
        }

        /**
         * Event handler
         */

        // Transition handlers
        _transitionItemMenuOpen(subMenu) {
            subMenu.classList.add(HAMBURGER_SUB_MENU_ACTIVE);
            subMenu.parentNode.classList.add(HAMBURGER_SUB_MENU_ACTIVE);
        }

        _transitionItemMenuClosed(subMenu) {
            subMenu.classList.remove(HAMBURGER_SUB_MENU_ACTIVE);
            subMenu.parentNode.classList.remove(HAMBURGER_SUB_MENU_ACTIVE);
        }

        /**
         * Function to check if the location is currently open
         */
        isOpen() {
            const modal =
                this.hamburgerMenuWrapper.querySelector(HAMBURGER_DIALOG);
            return modal.classList.contains(HAMBURGER_MENU_ACTIVE);
        }
    }

    const hamburgerMenu = document.querySelectorAll(HAMBURGER_MENU_SELECTOR);
    hamburgerMenu.forEach((item) => {
        // Create a new item to modify
        const DOMItem = item;

        // Attach the class instance to our DOMItem
        if (!DOMItem.hamburgerMenu) {
            DOMItem.hamburgerMenu = new HamburgerMenu(item);
        }
    });
}

_hamburgerMenu();
